module.exports = __webpack_public_path__ + "static/media/Estonia.912568dd.png";